import OapConcerns from './code/Scripts/components/OapConcerns.vue';

export default {
  components: {
    OapConcerns,
  },
};
